"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBadTwitterIdMsg = exports.URLTempAllowMsg = exports.CheckURLIsPhishingMsg = void 0;
const router_1 = require("@keplr-wallet/router");
const constants_1 = require("./constants");
const utils_1 = require("./utils");
class CheckURLIsPhishingMsg extends router_1.Message {
    static type() {
        return "check-url-is-phishing";
    }
    constructor() {
        super();
    }
    validateBasic() {
        const url = new URL(this.origin);
        // Will throw an error if url has not second level domain.
        utils_1.parseDomainUntilSecondLevel(url.origin);
    }
    approveExternal() {
        return true;
    }
    route() {
        return constants_1.ROUTE;
    }
    type() {
        return CheckURLIsPhishingMsg.type();
    }
}
exports.CheckURLIsPhishingMsg = CheckURLIsPhishingMsg;
class URLTempAllowMsg extends router_1.Message {
    constructor(url) {
        super();
        this.url = url;
    }
    static type() {
        return "url-temp-allow";
    }
    validateBasic() {
        const url = new URL(this.url);
        // Will throw an error if url has not second level domain.
        utils_1.parseDomainUntilSecondLevel(url.origin);
    }
    route() {
        return constants_1.ROUTE;
    }
    type() {
        return URLTempAllowMsg.type();
    }
}
exports.URLTempAllowMsg = URLTempAllowMsg;
class CheckBadTwitterIdMsg extends router_1.Message {
    constructor(id) {
        super();
        this.id = id;
    }
    static type() {
        return "check-bad-twitter-id";
    }
    validateBasic() {
        // noop
    }
    approveExternal() {
        return true;
    }
    route() {
        return constants_1.ROUTE;
    }
    type() {
        return CheckBadTwitterIdMsg.type();
    }
}
exports.CheckBadTwitterIdMsg = CheckBadTwitterIdMsg;
//# sourceMappingURL=messages.js.map